import React from 'react'
import styled from 'styled-components'
import { Heading, Text, Flex } from '@pancakeswap/uikit'
import { useToken } from 'hooks/Tokens'
import CopyToClipboard from '../CopyToClipboard'

const StyledLockCardHeader = styled(Flex)`
  padding-top: 12px;
  & > div {
    flex: 1;
  }
`

const Name = styled(Heading).attrs({ as: 'h3', size: 'lg' })`
  margin-bottom: 8px;
  text-align: left;
  padding-left: 8px;
`

const LockCardHeader: React.FC<{ name: string; address: string }> = ({ name, address }) => {
  return (
    <StyledLockCardHeader mb="24px" alignItems="center">
      <img src={`/images/tokens/${address}.png`} alt={address} width="96px" height="96px" />
      <div style={{ marginLeft: '12px' }}>
        <Name>{name}</Name>
        <CopyToClipboard content={address} />
      </div>
    </StyledLockCardHeader>
  )
}

export default LockCardHeader
